document.addEventListener('DOMContentLoaded', function () {
  if (window.AOS) {
    AOS.init();
  }
});

document.addEventListener('shopify:section:load', function () {
  if (window.AOS) {
    AOS.refreshHard();
  }
});
document.addEventListener('shopify:section:select', function () {
  if (window.AOS) {
    AOS.refreshHard();
  }
}); 